import { WithSubpages } from '../../subpages';
import { PAGE_TITLE } from '../../consts';
import { operatorLookupSubpages } from '../../subpages/dictionary';

import { MAIN_PAGE_PATH } from './paths';

const OperatorLookup = () => (
  <WithSubpages mainPagePath={MAIN_PAGE_PATH} title={PAGE_TITLE.OPERATOR_LOOKUP} items={operatorLookupSubpages} />
);

export default OperatorLookup;
